import { getHashObj, setHash, seasonConfigFallBack } from "@/utils/utils"
import { CustomWindowEvents } from "@/enums/customWindowEvents"

export default class SeasonManager {
	// singleton pattern
	#seasonConfig
	#season
	#originalSeason
	#seasonHashRegex = /season=[HE]/
	#seasons = {
		winter: "H",
		summer: "E",
	}

	constructor() {
		if (SeasonManager.singleton) {
			return SeasonManager.singleton
		}

		this.#seasonConfig = seasonConfigFallBack()

		SeasonManager.singleton = this
		return SeasonManager.singleton
	}

	get season() {
		return this.#season
	}
	get seasons() {
		return this.#seasons
	}
	get seasonConfig() {
		return this.#seasonConfig
	}

	get originalSeason() {
		return this.#originalSeason
	}

	#setSeason(newSeason) {
		this.#season = newSeason
		document.body.classList.add(
			newSeason === this.#seasons["winter"] ? "seasonWinter" : "seasonSummer"
		)
		document.body.classList.remove(
			newSeason === this.#seasons["summer"] ? "seasonWinter" : "seasonSummer"
		)
		if (newSeason === this.#seasons["summer"]) {
			this.#replaceWinterSsrTextWithSummer()
			this.#replaceSsrGalleryImagesWithSummer()
			this.#replaceWinterAdvisorTextWithSummer()
			this.#replaceWinterGeneralDescriptionTextWithSummer()
		} else if (newSeason === this.#seasons["winter"]) {
			// To replace the content if the season is switched because no avalabilities on summer
			this.#replacSummerSsrTextWithWinter()
			this.#replaceSsrGalleryImagesWithWinter()
			this.#replaceSummerAdvisorTextWithWinter()
			this.#replaceSummerGeneralDescriptionTextWithWinter()
		}
		window.dispatchEvent(new Event(CustomWindowEvents.CHANGE_SEASON))
	}

	#setOriginalSeason() {
		const { season } = getHashObj(window.location.hash)
		this.#originalSeason = season
	}

	#getCurrentMonthInt() {
		return new Date().getMonth() + 1 // +1 makes the months non-zero indexed - 1-12, because for no reason Javascript decided to have months 0-11
	}

	#replaceWinterSsrTextWithSummer() {
		// simple replacement
		const selectorsAndReplacements = {
			"[data-residenceSituationWinter]": [
				"residenceSituationSummer",
				"generalDescriptionSummer",
				"generalDescription",
			],
			"[data-generalDescriptionWinter]": [
				"residenceSituationSummer",
				"generalDescriptionSummer",
				"generalDescription",
			],
			"[data-informationWinter]": ["informationSummer", "information"],
		}
		Object.entries(selectorsAndReplacements).forEach(
			([selector, replacementsArray]) => {
				Array.from(document.querySelectorAll(selector)).forEach((element) => {
					for (const liheKey of replacementsArray) {
						const replacementText = window.lihe[liheKey]
						if (replacementText) {
							element.innerHTML = replacementText
							break
						}
					}
				})
			}
		)

		// special care
		// clubs
		const clubsDiv = document.querySelector("[data-clubsWinter]")
		if (clubsDiv && lihe.clubsWinter) {
			const clubs = lihe.clubsSummer
			if (!clubs) {
				clubsDiv.remove()
				return
			}
			let newHTML = ""
			clubs.forEach((club) => {
				newHTML += `
                <div class="mb-2">
                    <span>
                        <strong>${club.clubName ? club.clubName : ""}</strong>
                    </span>
                    <p class="mb-1">
                        ${club.minAndMaxAge ? club.minAndMaxAge : ""}
                    </p>
                    <p class="mb-2">
                        ${
													club.activitiesDescription
														? club.activitiesDescription
														: ""
												}
                    </p>
                </div>
                `
			})
			clubsDiv.innerHTML = newHTML
		}
	}

	#replacSummerSsrTextWithWinter() {
		// simple replacement
		const selectorsAndReplacements = {
			"[data-residenceSituationWinter]": [
				"residenceSituationWinter",
				"generalDescriptionWinter",
				"generalDescription",
			],
			"[data-generalDescriptionWinter]": [
				"residenceSituationWinter",
				"generalDescriptionWinter",
				"generalDescription",
			],
			"[data-informationWinter]": ["informationWinter", "information"],
		}
		Object.entries(selectorsAndReplacements).forEach(
			([selector, replacementsArray]) => {
				Array.from(document.querySelectorAll(selector)).forEach((element) => {
					for (const liheKey of replacementsArray) {
						const replacementText = window.lihe[liheKey]
						if (replacementText) {
							element.innerHTML = replacementText
							break
						}
					}
				})
			}
		)

		// special care
		// clubs
		const clubsDiv = document.querySelector("[data-clubsWinter]")
		if (clubsDiv && lihe.clubsWinter) {
			const clubs = lihe.clubsWinter
			if (!clubs) {
				clubsDiv.remove()
				return
			}
			let newHTML = ""
			clubs.forEach((club) => {
				newHTML += `
                <div class="mb-2">
                    <span>
                        <strong>${club.clubName ? club.clubName : ""}</strong>
                    </span>
                    <p class="mb-1">
                        ${club.minAndMaxAge ? club.minAndMaxAge : ""}
                    </p>
                    <p class="mb-2">
                        ${
													club.activitiesDescription
														? club.activitiesDescription
														: ""
												}
                    </p>
                </div>
                `
			})
			clubsDiv.innerHTML = newHTML
		}
	}

	#replaceWinterAdvisorTextWithSummer() {
		const advisorTextSpan = document.querySelector("[data-advisorAdvice]")
		const liheAdvisorAdviceSummer = window.lihe["advisorAdviceSummer"]
		if (liheAdvisorAdviceSummer) {
			advisorTextSpan.innerHTML = liheAdvisorAdviceSummer
		}
	}

	#replaceSummerAdvisorTextWithWinter() {
		const advisorTextSpan = document.querySelector("[data-advisorAdvice]")
		const liheAdvisorAdviceWinter = window.lihe["advisorAdvice"]
		if (liheAdvisorAdviceWinter) {
			advisorTextSpan.innerHTML = liheAdvisorAdviceWinter
		}
	}

	#replaceWinterGeneralDescriptionTextWithSummer() {
		const generalDescriptionParagraph = document.querySelector(
			"[data-liheGeneralDescription]"
		)
		const liheGeneralDescriptionSummer = window.lihe["generalDescriptionSummer"]
		if (liheGeneralDescriptionSummer) {
			generalDescriptionParagraph.innerHTML = liheGeneralDescriptionSummer
		}
	}
	#replaceSummerGeneralDescriptionTextWithWinter() {
		const generalDescriptionParagraph = document.querySelector(
			"[data-liheGeneralDescription]"
		)
		const liheGeneralDescriptionWinter = window.lihe["generalDescriptionWinter"]
		if (liheGeneralDescriptionWinter) {
			generalDescriptionParagraph.innerHTML = liheGeneralDescriptionWinter
		}
	}

	#buildCarouselLikeArrayImages() {
		let liheImages = []
		if (window.seasonManager.isWinter()) {
			liheImages =
				window.lihe["picturesLodgingWinter"] || window.lihe["picturesLodging"]
		} else if (window.seasonManager.isSummer()) {
			liheImages =
				window.lihe["picturesLodgingSummer"] || window.lihe["picturesLodging"]
		} else {
			throw new Error(
				"season in hash is mandatory, make sure the decideSeason function runs before this"
			)
		}

		const prestImageArrays = window.lihe.prestations.map(
			(prestObj) => prestObj.picturesAccomodation
		)
		const prestImages = prestImageArrays.flat()
		const srcObjectArrayWithAllImages = [...liheImages, ...prestImages]
		return srcObjectArrayWithAllImages
	}

	#replaceSsrGalleryImagesWithSummer() {
		const picturesSummer = window.lihe["picturesLodgingSummer"]
		const newSources =
			picturesSummer && picturesSummer.length >= 5
				? picturesSummer
				: this.#buildCarouselLikeArrayImages()
		if (!newSources) return

		Array.from(document.querySelectorAll("img.gallery-img")).forEach(
			(img, img_i) => {
				const sourceObj = newSources[img_i]
				if (!sourceObj) {
					console.log(`[replaceSsrGalleryImagesWithSummer] dont have source`)
					return
				}

				if (img_i === 0) {
					const newSrc =
						sourceObj["imgXL"] ||
						sourceObj["imgLarge"] ||
						sourceObj["imgMedium"] ||
						sourceObj["imgSmall"] ||
						sourceObj["img"]
					img.src = newSrc
				} else {
					const newSrc =
						sourceObj["imgMedium"] ||
						sourceObj["imgLarge"] ||
						sourceObj["imgXL"] ||
						sourceObj["imgSmall"] ||
						sourceObj["img"]
					img.src = newSrc
				}
			}
		)
	}
	#replaceSsrGalleryImagesWithWinter() {
		const picturesWinter = window.lihe["picturesLodgingWinter"]
		const newSources =
			picturesWinter && picturesWinter.length >= 5
				? picturesWinter
				: this.#buildCarouselLikeArrayImages()
		if (!newSources) return

		Array.from(document.querySelectorAll("img.gallery-img")).forEach(
			(img, img_i) => {
				const sourceObj = newSources[img_i]
				if (!sourceObj) {
					console.log(`[replaceSsrGalleryImagesWithWinter] dont have source`)
					return
				}

				if (img_i === 0) {
					const newSrc =
						sourceObj["imgXL"] ||
						sourceObj["imgLarge"] ||
						sourceObj["imgMedium"] ||
						sourceObj["imgSmall"] ||
						sourceObj["img"]
					img.src = newSrc
				} else {
					const newSrc =
						sourceObj["imgMedium"] ||
						sourceObj["imgLarge"] ||
						sourceObj["imgXL"] ||
						sourceObj["imgSmall"] ||
						sourceObj["img"]
					img.src = newSrc
				}
			}
		)
	}

	isWinter() {
		return this.season === this.#seasons["winter"]
	}

	isSummer() {
		return this.season === this.#seasons["summer"]
	}

	decideSeason() {
		const match = window.location.hash.match(this.#seasonHashRegex)
		if (match) {
			// if season is already set in the url
			const seasonInUrl = match[0].split("=")[1]
			this.#setSeason(seasonInUrl)
		} else {
			// if there is no season in the url - decide season based on current date
			let currentMonthInt
			if (getHashObj(window.location.hash)["BeginDate"]) {
				currentMonthInt = parseInt(
					getHashObj(window.location.hash)["BeginDate"].split("/")[1]
				)
			} else {
				currentMonthInt = this.#getCurrentMonthInt()
			}

			if (this.#seasonConfig.winter.includes(currentMonthInt)) {
				setHash({ season: this.#seasons["winter"] })
				this.#setSeason(this.#seasons["winter"])
			} else if (this.#seasonConfig.summer.includes(currentMonthInt)) {
				setHash({ season: this.#seasons["summer"] })
				this.#setSeason(this.#seasons["summer"])
			}
		}
		return this.#season
	}

	switchSeasonWithoutReloading() {
		const [urlWithoutHash, hash] = window.location.href.split("#")
		const hashParams = getHashObj(hash)
		const newSeason =
			this.#season === this.#seasons["winter"]
				? this.#seasons["summer"]
				: this.#seasons["winter"]
	
		hashParams.season = newSeason
		this.#setSeason(newSeason)
	
		// Construct the new hash string from hashParams
		const newHash = Object.entries(hashParams).map(([key, value]) => `${key}=${value}`).join('&');
	
		// Use history.replaceState to update the URL without adding a history entry
		history.replaceState(null, '', `${urlWithoutHash}#${newHash}`);
	}

	switchSeason() {
		const urlWithoutHash = window.location.href.split("#")[0]
		const newSeason =
			this.#season === this.#seasons["winter"]
				? this.#seasons["summer"]
				: this.#seasons["winter"]
		const newURL = `${urlWithoutHash}#season=${newSeason}`

		history.replaceState(null, '', newURL)
		window.location.reload()
	}

	init() {
		this.decideSeason()
		this.#setOriginalSeason()
	}
}
